import React from 'react';
import styles from './AccordionItem.module.css';

import addCircleIcon from '../../../images/add-circle.svg';
import minusRoundIcon from '../../../images/minus-round.svg';

import Slide from 'react-reveal/Slide';


const AccordionItem = ({ heading, description, image, click, id, height }) => (
  <Slide bottom>
  <div className={styles.AccordionItem}>
    <div onClick={click} className={styles.top} style={{
      backgroundImage: `url(${image})`,
      backgroundSize: 'cover',
      height: `${height ? height : 'unset'}`
    }}>
      <p>click</p>
      <h2>{heading}</h2>
      <img src={id === 0 ? minusRoundIcon : addCircleIcon} alt="" />
    </div>
    <div className={id === 0 ? styles.description : styles.description + " hide"}>
      {description}
    </div>
  </div>
  </Slide>
)

export default AccordionItem;